import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { AddSubtaskRequest, CorrespondenceEmailModel, CorrespondenceReplyResponse, GetCorrespondenceResponse, MarkAllAsReadRequest, UpdateCorrespondenceReadIndicator, VesselCorrespondence } from "../models/message-centre.models";
import { SubtaskApiRoutes } from "../constants/route.constant";
import { SubtaskSourceEnum } from "@rightship-tech/common-ui/models/basic.models";

@autoinject
export class MessageCentreService {
    
    private rightShipQiUrl: string;

    constructor(private requestClient: RequestClientService, private configService: ConfigService) {
        this.rightShipQiUrl = this.configService.config.urls.rightShipPlatformApiUrl;
    }

    public getCorrespondences(entityId: number, entityTypeId: number, subtaskId: number = null, filter: string = null, rfiTypeIds: number[] = null, encryptedParams?: string): Promise<VesselCorrespondence[]> {
        return this.requestClient.get<VesselCorrespondence[]>(`${this.rightShipQiUrl}/${SubtaskApiRoutes.GetCorrespondences}/${entityId}/${entityTypeId}`,
            { subtaskId: subtaskId, filter: filter, rfiTypeIds: rfiTypeIds, encryptedParams: encryptedParams });
    }

    public getCorrespondence(guid: string, encryptedParams: string) {
        return this.requestClient.get<GetCorrespondenceResponse>(`${this.rightShipQiUrl}/${SubtaskApiRoutes.GetCorrespondence}/${guid}`, {
            encryptedParams: encryptedParams
        });
    }

    public getSubtaskId(encryptedGuid?: string, encryptedSubCorrespondenceId?: string): Promise<number> {
        return this.requestClient.get<number>(`${this.rightShipQiUrl}/${SubtaskApiRoutes.GetSubtaskId}`,
            { encryptedGuid, encryptedSubCorrespondenceId });
    }

    public reply(guid: string, subtaskCorrespondenceId: number, message: string, submit: boolean, isFromAdmin: boolean, changeStatusToAwaitingResponse: boolean, changeStatusToPendingReview: boolean,
        subtaskTypes: number[], emails: CorrespondenceEmailModel[], statusSnippet: string, comment: string, ea: string, messageSenderEmail?: string, messageSenderEmailTypeName?: string): Promise<CorrespondenceReplyResponse> {
        return this.requestClient.post(`${this.rightShipQiUrl}/${SubtaskApiRoutes.ReplyCorrespondence}`, {}, {
            guid: guid,
            emails: emails,
            message: message,
            submit: submit,
            subtaskCorrespondenceId: subtaskCorrespondenceId,
            isFromAdmin: isFromAdmin,
            changeStatusToAwaitingResponse: changeStatusToAwaitingResponse,
            changeStatusToPendingReview: changeStatusToPendingReview,
            subtaskTypes: subtaskTypes,
            comment: comment,
            statusSnippet: statusSnippet,
            ea: ea,
            messageSenderEmail: messageSenderEmail,
            messageSenderEmailTypeName: messageSenderEmailTypeName,
            subtaskSourceId: SubtaskSourceEnum.MessageCentre
        });
    }

    public addSubtask(request: AddSubtaskRequest): Promise<number> {
        return this.requestClient.postFormData(`${this.rightShipQiUrl}/${SubtaskApiRoutes.AddSubtask}`, request);
    }

    public updateCorrespondenceReadIndicator(request: UpdateCorrespondenceReadIndicator): Promise<any> {
        return this.requestClient.post(`${this.rightShipQiUrl}/${SubtaskApiRoutes.UpdateCorrespondenceReadIndicator}`, {}, request);
    }

    public markAllAsRead(subtaskId: number, request: MarkAllAsReadRequest): Promise<any> {
        return this.requestClient.post(`${this.rightShipQiUrl}/${SubtaskApiRoutes.MarkAllAsRead}/${subtaskId}`, {}, request);
    }
    
    public addAttachmentToEntityDocuments(path: string, filename: string, entityId: number, entityTypeId: number, attachmentTypeId: number): Promise<void> {
        return this.requestClient.post(`${this.rightShipQiUrl}/${SubtaskApiRoutes.AddAttachmentToEntityDocuments}`, {}, { filePath: path, fileName: filename, entityId: entityId, entityTypeId: entityTypeId, attachmentTypeId: attachmentTypeId });
    }

    public setAsAwaitingReponse(subtaskId: number): Promise<any> {
        return this.requestClient.post(`${this.rightShipQiUrl}/${SubtaskApiRoutes.SetAsAwaitingReponse}/${subtaskId}`, { subtaskStatusSourceId: SubtaskSourceEnum.MessageCentre });
    }

    public setAsClosed(subtaskId: number): Promise<any> {
        return this.requestClient.post(`${this.rightShipQiUrl}/${SubtaskApiRoutes.SetAsClosed}/${subtaskId}`, { subtaskStatusSourceId: SubtaskSourceEnum.MessageCentre });
    }
}
